import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import {
  ColumnOrderState,
  OnChangeFn,
  SortingState,
  VisibilityState,
} from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@model/enum/state.enum';

import { EmspBoEmspUserListActionsColumn } from './emsp-bo-emsp-user-list-actions.column';
import {
  EMSP_BO_EMSP_USER_LIST_COLUMN_LIST,
  EMSP_BO_EMSP_USER_LIST_COLUMN_ORDER,
  EMSP_BO_EMSP_USER_LIST_COLUMN_VISIBILITY,
  emspBoEmspUserListColumnHelper,
} from './emsp-bo-emsp-user-list.config';

interface EmspBoEmspUserListViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<EmspUserModel>;
  columnVisibility?: VisibilityState;
  columnOrder?: ColumnOrderState;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationPageNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
  renderColumnSettings?: (close: () => void) => React.ReactNode;
  onHideColumn?: (columnId: string) => void;
  onColumnOrderChange?: OnChangeFn<ColumnOrderState>;
}

export const EmspBoEmspUserListView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  columnVisibility = EMSP_BO_EMSP_USER_LIST_COLUMN_VISIBILITY,
  columnOrder = EMSP_BO_EMSP_USER_LIST_COLUMN_ORDER,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
  renderColumnSettings,
  onHideColumn,
  onColumnOrderChange,
}: EmspBoEmspUserListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // LIST //////////////////////////////////////////////////////////////////////

  const columns = useMemo(
    () => [
      ...EMSP_BO_EMSP_USER_LIST_COLUMN_LIST,
      emspBoEmspUserListColumnHelper.display(EmspBoEmspUserListActionsColumn),
    ],
    [],
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={columns}
      columnOrder={columnOrder}
      columnVisibility={columnVisibility}
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.emsp-user-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
      renderColumnSettings={renderColumnSettings}
      onHideColumn={onHideColumn}
      onColumnOrderChange={onColumnOrderChange}
    />
  );
};
